{
  "quantity-box": {
    "width": 162,
    "height": 73
  },
  "plus": {
    "width": 49,
    "height": 61
  },
  "minus": {
    "width": 44,
    "height": 20
  },
  "subtotal": {
    "width": 212,
    "height": 56
  },
  "digit-1": {
    "width": 21,
    "height": 49
  },
  "digit-2": {
    "width": 48,
    "height": 57
  },
  "digit-3": {
    "width": 50,
    "height": 66
  },
  "digit-4": {
    "width": 51,
    "height": 63
  },
  "digit-5": {
    "width": 40,
    "height": 58
  },
  "digit-6": {
    "width": 38,
    "height": 65
  },
  "digit-7": {
    "width": 41,
    "height": 53
  },
  "digit-8": {
    "width": 44,
    "height": 64
  },
  "digit-9": {
    "width": 37,
    "height": 68
  },
  "digit-0": {
    "width": 59,
    "height": 71
  },
  "currency-dollar": {
    "width": 313,
    "height": 581
  },
  "decimal-point": {
    "width": 51,
    "height": 53
  },
  "checkout-button": {
    "width": 230,
    "height": 71
  },
  "title-riley-level": {
    "width": 476.794,
    "height": 330.582
  },
  "title-farza-level": {
    "width": 575.362,
    "height": 361.157
  }
}
